import { useEffect, useState } from 'react';
import { contactApiKeyStore } from '../../../../api/contact-api-key-store';
import { gridApiKeyStore } from '../../../../api/grid-api-key-store';
import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { Contact } from '../../../../models/contact';
import { GridColumnConfig, GridPreference } from '../../../../models/gridCoumnConfig';
import { UserPermissionName } from '../../../../models/user-permission-name';
import { columns } from './customer-contacts-columns';
import { useSaveData } from '../../../../hooks/useSaveData';
import { State } from '@progress/kendo-data-query';
import useDebounce from '../../../../hooks/use-debounce';

interface ProjectsTabProps {
  officeID: number;
}
export const CustomerDetailsTab = ({ officeID }: ProjectsTabProps) => {
  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout,
  } = useLoadData<ApiResponse<GridPreference>>(gridApiKeyStore.getGridLayout('Office Details', 'Contacts'));

  const {
    isLoading: isLoadingFile,
    data: contacts,
    refetch,
  } = useLoadData<ApiResponse<Contact[]>>(contactApiKeyStore.getOfficeContacts(officeID));

  const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredContacts, setFilteredContacts] = useState<Contact[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredContactList = contacts?.data?.filter((file) =>
      Object.values(file).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredContacts(filteredContactList || []);
  }, [debouncedSearchTerm, contacts?.data]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'Contacts',
      pageName: 'Office Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'Contacts',
      pageName: 'Office Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      // if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      // }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);
  return (
    <SiTrackGrid
      fileTitle='office_contact'
      columns={columns}
      dataItemKey="contactsID"
      // queryConfig={contactApiKeyStore.getOfficeContacts(officeID)}
      actionPermissions={{
        export: UserPermissionName.DOWNLOAD_GRID,
      }}
      // -----------------Grid Layout-------
      dataItems={filteredContacts || []}
      reorderable
      handleSearch={handleInputChange}
      handleSaveLayout={handleSaveLayout}
      isSaveLayout={true}
      gridConfigFromApi={gridConfig}
      handleResetLayout={handleResetLayout}
    // -----------------Grid Layout-------
    />
  );
};
